module.exports = __webpack_public_path__ + "img/collection-engagementRingsDainty@2x.92c3492.webp";